<div class="pb-5" style="height: 50vh;">
    <div id="whHealthinessChart" class="h-full"></div>
</div>
